import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxibookinginvadodara() {



  const cardData =
  {
    keyword: 'Taxi Booking in Vadodara',
    heading: 'Aaryan Travels: Taxi Booking in Vadodara',
    headingDescription: ' Aaryan Travels offers quick and reliable Taxi Booking in Vadodara for local city rides, airport transfers, office commute, and outstation travel. Whether you’re heading to Vadodara Airport, attending a business meeting, or planning a weekend trip to Ahmedabad, Surat, or Statue of Unity, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable journey. With professional chauffeurs, doorstep pickup, transparent fares, and 24/7 service availability, we make cab booking in Vadodara effortless and efficient. From Alkapuri to Gotri, Manjalpur to Makarpura, Aaryan Travels is your trusted choice for safe and on-time taxi services across Vadodara.',

    top: 'Top Places to Visit in Vadodara with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lakshmi Vilas Palace",
    "description": "Lakshmi Vilas Palace is one of the grandest royal palaces in India, built by Maharaja Sayajirao Gaekwad III in 1890. It is four times larger than Buckingham Palace and displays a fusion of Indo-Saracenic architecture. Visitors marvel at its ornate interiors, Belgian stained glass, and Durbar Hall. The palace complex also features a museum and golf course. Lakshmi Vilas Palace is Vadodara’s majestic symbol of royal elegance."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is a sprawling public garden spread over 100 acres, offering a zoo, planetarium, toy train, and Baroda Museum. Families enjoy leisurely walks among fountains, floral displays, and shaded pathways. The museum showcases diverse artifacts including an Egyptian mummy. It is the perfect spot for recreation and education. Sayaji Baug is Vadodara’s green heart of relaxation and culture."
  },
  {
    "title": "EME Temple (Dakshinamurthy Temple)",
    "description": "Managed by the Indian Army, the EME Temple is a unique place of worship built in modern aluminum-clad architecture. It represents unity across religions with elements from Hindu, Islamic, Christian, and Buddhist designs. The serene atmosphere and immaculate premises make it ideal for meditation. Visitors admire its symbolic architecture and peaceful aura. EME Temple is Vadodara’s spiritual emblem of harmony."
  },
  {
    "title": "Ajwa Water Park & Ajwa Lake",
    "description": "Ajwa Water Park is a popular amusement hub featuring exciting slides, wave pools, and rain dance areas. Located next to Ajwa Lake, visitors enjoy boat rides and sunset views over the calm waters. Lush surroundings and fresh air make it perfect for picnics. It is especially loved by families and children. Ajwa is Vadodara’s refreshing blend of fun and tranquility."
  },
  {
    "title": "Maharaja Fateh Singh Museum",
    "description": "Situated within the Lakshmi Vilas Palace estate, the Maharaja Fateh Singh Museum displays a rich collection of royal paintings, bronze sculptures, and antique furniture. Notable works include masterpieces by Raja Ravi Varma. Each gallery reflects the lifestyle and artistic taste of the Gaekwad dynasty. Art lovers find it deeply captivating. The museum is Vadodara’s elegant tribute to heritage and fine arts."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a cenotaph built by Maharaja Sayajirao Gaekwad III in memory of the royal family. Its architecture features murals inspired by Indian epics like Mahabharata and Ramayana. The peaceful ambiance offers spiritual serenity for visitors. It serves as a symbol of loyalty and reverence. Kirti Mandir is Vadodara’s tranquil memorial of royal legacy."
  },
  {
    "title": "Sursagar Lake",
    "description": "Sursagar Lake is a scenic waterbody located in the heart of Vadodara, famous for its large Shiva statue rising from the center. Illuminated in the evening, it creates a beautiful lakeside view. Visitors enjoy peaceful strolls along the stone embankments. During festivals, the lake becomes a vibrant gathering spot. Sursagar is Vadodara’s serene reflection of devotion and beauty."
  },
  {
    "title": "Laxmi Vilas Palace Golf Club",
    "description": "Located within the palace grounds, the Laxmi Vilas Golf Club offers a lush 10-hole course surrounded by royal architecture and nature. Peacocks often roam freely across the lawns. Golf enthusiasts enjoy playing in a regal environment. It is also used for high-end social events. The Golf Club is Vadodara’s royal retreat for leisure and sport."
  },
  {
    "title": "Inorbit Mall Vadodara",
    "description": "Inorbit Mall is a premier shopping and entertainment hub featuring international brands, food courts, and multiplex cinema. The lively atmosphere makes it a popular weekend destination for families and youth. Fashion stores and arcade games add to the excitement. It reflects the city’s modern lifestyle. Inorbit Mall is Vadodara’s one-stop destination for fun and fashion."
  },
  {
    "title": "Narmada Canal Viewpoint",
    "description": "The Narmada Canal passing through Vadodara offers picturesque locations perfect for evening drives and roadside relaxation. The calm flowing waters against green landscapes create a soothing experience. Locals often stop here for photography and fresh air. During monsoon, the surroundings turn lush and vibrant. The canal viewpoint is Vadodara’s peaceful escape into nature."
  }
],


"services": [
  {
    "name": "Taxi Booking in Vadodara",
    "description": "Our Taxi Booking service in Vadodara offers a seamless and efficient way to reserve your ride anytime, anywhere. Whether it's a quick city commute or a long-distance trip, we ensure timely pickups and professional service. With multiple booking options including phone and online, customers enjoy the convenience of instant confirmations and transparent pricing without any hidden charges."
  },
  {
    "name": "Book Taxi Vadodara",
    "description": "Booking a taxi in Vadodara has never been easier with our streamlined booking system. Designed to cater to all your travel needs, our fleet ranges from compact sedans to spacious SUVs. Whether you need a taxi for business, leisure, or airport transfers, we provide prompt, reliable service with verified drivers who prioritize your safety and comfort."
  },
  {
    "name": "Online Cab Vadodara",
    "description": "Experience hassle-free travel with our Online Cab service in Vadodara. Our user-friendly digital platform allows you to book cabs instantly, track your ride in real time, and make secure payments online. Perfect for tech-savvy users and busy professionals, this service ensures you get a reliable taxi without any waiting or confusion."
  },
  {
    "name": "Vadodara Cab Near Me",
    "description": "Looking for a 'Cab Near Me' in Vadodara? Our wide network of local drivers guarantees fast taxi dispatch from your nearest location. This service reduces wait times significantly and ensures quick and efficient travel throughout the city. Ideal for urgent rides or spontaneous trips, find a nearby cab quickly with us."
  },
  {
    "name": "Affordable Taxi Vadodara",
    "description": "Our Affordable Taxi Vadodara service offers budget-friendly rides without compromising on quality or safety. Perfect for daily commuters, students, and cost-conscious travelers, we maintain transparent pricing, no surge fees, and well-maintained vehicles to provide economical transportation solutions all year round."
  },
  {
    "name": "Local Cab Booking Vadodara",
    "description": "For your everyday travel needs within Vadodara, our Local Cab Booking service is the go-to option. Whether it's a ride to work, shopping, or school, we ensure comfortable and timely pickups. Our professional drivers have excellent knowledge of Vadodara’s routes, helping you navigate traffic and reach your destination smoothly."
  },
  {
    "name": "Sedan Cab Vadodara",
    "description": "Our Sedan Cab service in Vadodara features a fleet of well-maintained, comfortable sedans ideal for both business and personal travel. Enjoy spacious interiors, air conditioning, and professional drivers who prioritize your convenience and safety. Whether for airport transfers or city rides, our sedan cabs provide a stylish and reliable travel option."
  },
  {
    "name": "Vadodara Outstation Taxi",
    "description": "Travel beyond Vadodara with confidence using our Outstation Taxi service. Whether it's a weekend getaway, business trip, or family visit, our outstation cabs offer comfort, reliability, and competitive pricing. Choose from one-way or round-trip packages, with options for sedans and SUVs to suit your group size and luggage needs."
  },
  {
    "name": "Vadodara City Taxi",
    "description": "Navigate Vadodara effortlessly with our City Taxi service. Available 24x7, these cabs are perfect for running errands, attending meetings, or visiting tourist spots. We prioritize prompt service, clean vehicles, and courteous drivers to provide you with a smooth and convenient urban travel experience."
  },
  {
    "name": "SUV Taxi Vadodara",
    "description": "For group travel or when you need extra space and comfort, our SUV Taxi service in Vadodara is the ideal choice. Our SUVs are well-maintained and driven by professional chauffeurs who ensure a safe and pleasant ride. Suitable for family outings, business trips, or special occasions, book your SUV taxi today for a premium experience."
  },
  {
    "name": "Taxi Hire Vadodara",
    "description": "Taxi Hire in Vadodara is perfect for travelers looking for flexible and reliable transportation options. Whether you need a cab for an hour, a full day, or multiple days, our service offers customized packages to fit your schedule and budget. Enjoy personalized service with transparent rates and professional drivers."
  },
  {
    "name": "24x7 Taxi Vadodara",
    "description": "Our 24x7 Taxi service in Vadodara ensures that you have access to reliable transportation anytime, day or night. Ideal for shift workers, late-night travelers, and early morning airport pickups, this round-the-clock service guarantees punctuality and safety, no matter the hour."
  },
  {
    "name": "Vadodara Travel Taxi",
    "description": "Explore Vadodara and beyond with our Travel Taxi service, designed for tourists, business travelers, and local commuters alike. Whether you want to visit heritage sites, attend business meetings, or travel to nearby cities, our knowledgeable drivers and comfortable vehicles make every journey enjoyable and hassle-free."
  },
  {
    "name": "Airport Taxi Vadodara",
    "description": "Ensure timely and stress-free airport transfers with our Airport Taxi service in Vadodara. We monitor flight schedules in real time to offer punctual pickups and drop-offs, so you never miss a flight. Our professional drivers assist with luggage and provide a comfortable ride to and from Vadodara Airport."
  },
  {
    "name": "Reliable Taxi Vadodara",
    "description": "Our Reliable Taxi service in Vadodara is committed to delivering consistent quality, safety, and customer satisfaction. With a focus on punctuality, vehicle maintenance, and courteous drivers, we ensure that every ride meets your expectations. Trust us for dependable transportation solutions tailored to your needs."
  }
],
"tableData": [
  ["Taxi Booking in Vadodara", "Book Taxi Vadodara"],
  ["Online Cab Vadodara", "Vadodara Cab Near Me"],
  ["Affordable Taxi Vadodara", "Local Cab Booking Vadodara"],
  ["Sedan Cab Vadodara", "Vadodara Outstation Taxi"],
  ["Vadodara City Taxi", "SUV Taxi Vadodara"],
  ["Taxi Hire Vadodara", "24x7 Taxi Vadodara"],
  ["Vadodara Travel Taxi", "Airport Taxi Vadodara"],
  ["Reliable Taxi Vadodara", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Taxi Booking Service in Vadodara",
    "WhyChoosedescription": "Aaryan Travels provides reliable and convenient taxi booking services across Vadodara for all your travel requirements."
  },
  {
    "WhyChooseheading": "Prompt and Convenient Pickup Across Vadodara",
    "WhyChoosedescription": "Our drivers are always nearby to ensure timely pickups and hassle-free rides within the city."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Ride",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis designed for your safety and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Vadodara Roads",
    "WhyChoosedescription": "Our professional drivers know Vadodara well, ensuring efficient and smooth journeys."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for a stress-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, changes, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Trips",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance travel as per your needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Choices to Suit Your Group and Luggage",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage requirements."
  }
]


























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer taxi booking services in Vadodara?',
    answer: 'Yes, Aaryan Travels provides reliable and convenient taxi booking services across Vadodara for local and outstation travel.',
  },
  {
    question: 'How can I book a taxi in Vadodara with Aaryan Travels?',
    answer: 'You can book your taxi easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of taxis are available for booking in Vadodara?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Can I book a taxi for both local travel and outstation trips from Vadodara?',
    answer: 'Yes, Aaryan Travels provides taxi services for local rides as well as outstation trips from Vadodara to various destinations.',
  },
  {
    question: 'Are the drivers experienced and familiar with Vadodara routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with Vadodara and surrounding areas to ensure safe travel.',
  },
  {
    question: 'Is hourly taxi rental available in Vadodara?',
    answer: 'Yes, we offer flexible hourly rental packages for taxi hire in Vadodara.',
  },
  {
    question: 'Are safety and hygiene protocols followed for taxi services in Vadodara?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to protect passengers.',
  },
  {
    question: 'Is taxi booking service in Vadodara available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 taxi booking and services throughout Vadodara.',
  },
  {
    question: 'What payment options are accepted for taxi bookings in Vadodara?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for smooth and secure transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations within Vadodara?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Vadodara as per your travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Shah',
    feedback: 'The taxi booking service by Aaryan Travels in Vadodara was seamless and efficient. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Mehta',
    feedback: 'Excellent taxi booking experience in Vadodara with Aaryan Travels. Very reliable and user-friendly.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Booking in Vadodara",
  "image": "https://aaryantravels.com/assets/images/taxi-booking-vadodara.jpg", // replace with actual image URL
  "description": "Convenient and affordable taxi booking service in Vadodara by Aaryan Travels. Available 24x7 for local, outstation, sedan, SUV, and airport taxi rides.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",  // example rating, update if needed
    "ratingCount": "1800", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "950",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/taxi-booking-vadodara"
  }
};






  return (
    <div>
<Helmet>
  <title>Taxi Booking in Vadodara | Affordable & Reliable Cab Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Convenient and affordable taxi booking service in Vadodara by Aaryan Travels. Available 24x7 for local, outstation, sedan, SUV, and airport taxi rides."
  />
  <meta
    name="keywords"
    content="Taxi Booking in Vadodara, Book Taxi Vadodara, Online Cab Vadodara, Vadodara Cab Near Me, Affordable Taxi Vadodara, Local Cab Booking Vadodara, Sedan Cab Vadodara, Vadodara Outstation Taxi, Vadodara City Taxi, SUV Taxi Vadodara, Taxi Hire Vadodara, 24x7 Taxi Vadodara, Vadodara Travel Taxi, Airport Taxi Vadodara, Reliable Taxi Vadodara"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxibookinginvadodara;